const colorArrays = {
	light: ['primary.washedOpaque', 'primary.light'],
	main: ['primary.light', 'primary.main'],
	dark: ['primary.main', 'primary.dark'],
	warning: ['common.orange', 'error.main'],
};

export default colorArrays;
